import * as pages from '../pages/**/*.js'
import * as components from '../components/**/*.js'
import * as alias from '&/alias.json'

import Scroller from '&/class/Scroller'
import Form from '&/class/Form'
import Ajax from '&/class/Ajax'

export default class WordPress {
  constructor () {
    this.slug = (alias[wp.slug] || wp.slug).charAt(0).toUpperCase() + (alias[wp.slug] || wp.slug).slice(1)
    this.page = pages[this.slug]
    this.params = {
      wp,
      $ajax: new Ajax({ uri: wp.theme_directory_uri }),
      $form: new Form(),
      $scroller: null
    }
  }

  enableLocomotive (container = '[data-scroll-container]') {
    this.params.$scroller = new Scroller(container).init()
    this.params.$form.setScroller(this.params.$scroller)
  }

  // Un composant qui plante (page/slug JS manquant, bug ponctuel...) ne
  // doit jamais empêcher les autres de s'exécuter — en particulier Reveal,
  // dont dépend l'apparition des images.
  safeRender (fn, label) {
    try {
      fn?.render(this.params)
    } catch (error) {
      console.error(`[WordPress] échec au rendu de "${label}"`, error)
    }
  }

  init () {
    // Global components
    Object.keys(components)
    ?.filter(key => key[0] !== '_')
    ?.forEach(key => this.safeRender(components[key][key], key))
    // Page components
    Object.keys(this.page?.components || {})
    ?.filter(key => key[0] !== '_')
    ?.forEach(key => this.safeRender(this.page?.components[key][key], key))
    // Page
    this.safeRender(this.page?.[this.slug], this.slug)
  }
}